/* ================================================================
   NewPharma — cronometros de oferta

   Uno solo para todo el sitio. Lo usan hoy:
     - sections/slideshow.liquid        (sobre el banner del home)
     - sections/template--product.liquid (bajo el precio de la ficha)

   Estaba escrito adentro del slideshow. Al necesitarlo tambien en la
   ficha de producto se movio aca, en vez de copiarlo: dos copias de la
   misma logica se desincronizan a la primera correccion.

   LOS NUMEROS YA VIENEN DIBUJADOS DESDE EL SERVIDOR. Liquid calcula
   cuanto falta con la zona horaria de la tienda y lo escribe en el
   HTML; esto solo los hace avanzar. Si el JS no corre, el cliente igual
   ve el tiempo restante -congelado, pero correcto al cargar la pagina-.

   El segundero arranca del valor que calculo Liquid, NO de la hora del
   navegador: asi el reloj mal puesto de un visitante no cambia cuando
   termina la oferta.

   Estilos: bloque 49 (banner) y bloque 50 (ficha) de custom.css.
   ================================================================ */
(function () {
  'use strict';

  function arrancar(el) {
    if (el.dataset.npCdActivo === '1') return;   // por si la seccion se redibuja
    el.dataset.npCdActivo = '1';

    var restante = parseInt(el.getAttribute('data-np-cd-end'), 10);
    if (isNaN(restante) || restante <= 0) return;

    var ocultar = el.getAttribute('data-np-cd-hide') === 'true';
    var arranqueMs = Date.now();
    var elD = el.querySelector('[data-d]');
    var elH = el.querySelector('[data-h]');
    var elM = el.querySelector('[data-m]');
    var elS = el.querySelector('[data-s]');
    var timer = null;

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function set(nodo, val) {
      if (nodo && nodo.textContent !== val) nodo.textContent = val;
    }

    function tick() {
      var pasado = Math.floor((Date.now() - arranqueMs) / 1000);
      var falta = restante - pasado;

      if (falta <= 0) {
        if (timer) clearInterval(timer);
        el.hidden = true;

        // En el banner, la diapositiva se retira en vivo para quien ya
        // tenia la pagina abierta; para quien entra despues, Liquid ni la
        // dibuja. En la ficha de producto no hay `.swiper-slide` alrededor,
        // asi que este bloque simplemente no hace nada y solo desaparece
        // el cronometro.
        if (ocultar) {
          try {
            var slide = el.closest('.swiper-slide');
            if (slide) {
              var cont = slide.closest('.swiper');
              slide.remove();
              if (cont && cont.swiper) cont.swiper.update();
            }
          } catch (e) { /* si falla, queda la diapositiva pero sin reloj */ }
        }
        return;
      }

      set(elD, String(Math.floor(falta / 86400)));
      set(elH, pad(Math.floor(falta / 3600) % 24));
      set(elM, pad(Math.floor(falta / 60) % 60));
      set(elS, pad(falta % 60));
    }

    tick();
    timer = setInterval(tick, 1000);
  }

  function iniciarTodos() {
    document.querySelectorAll('[data-np-cd]').forEach(arrancar);
  }

  iniciarTodos();

  // El editor de Shopify vuelve a dibujar la seccion al cambiar un ajuste,
  // y el carrito redibuja partes de la pagina. Sin esto, el cronometro
  // quedaria congelado despues de cualquiera de las dos cosas.
  document.addEventListener('shopify:section:load', iniciarTodos);
})();
